export const en = {
  translations: {
    seo_title: "Comprehensive.io - Pay Range Tracker",
    seo_description:
      "Access real-time compensation benchmarking data from 3,000+ companies — for free.",
    seo_separator: "-",
  },
};
